module.exports = ".site-footer{background: #FFF;}.page-login-v3 .panel{width: 100%}.page-content,.panel-body{padding:30px 10px}.panel-body{position:relative}.panel-title{display:block;margin-top:0;margin-bottom:0;padding:20px 10px;font-size:18px;color:#37474f}.in{opacity:1!important}.modal-backdrop.fade{opacity:.5!important}"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./node_modules/postcss-loader/lib??embedded!./src/assets/evs/css/style.min.css
// module id = ./node_modules/raw-loader/index.js!./node_modules/postcss-loader/lib/index.js??embedded!./src/assets/evs/css/style.min.css
// module chunks = styles